import en from '../i18n/en.js';
import cs from '../i18n/cs.js';
import vi from '../i18n/vi.js';
import uk from '../i18n/uk.js';

const dictionaries = { en, cs, vi, uk };

/**
 * Tiny i18n composable.
 *
 *   const { t } = useTranslations('cs');
 *   t('title')                              // → 'MoonGroup asistent'
 *   t('composer.charCount', { used, max })  // → '12/2000'
 */
export function useTranslations(locale = 'en') {
    const dict = dictionaries[locale] ?? dictionaries.en;

    function get(path) {
        return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), dict);
    }

    function interpolate(template, vars = {}) {
        return String(template).replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : `{${k}}`));
    }

    function t(path, vars) {
        const value = get(path);
        if (value === undefined) return path;
        if (typeof value === 'string') return vars ? interpolate(value, vars) : value;
        return value;
    }

    return { t, locale };
}
